<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>{{data.mensage}}</div>
<mat-dialog-actions align="center" class="mt-3">
  <button mat-button [mat-dialog-close]="false" class="mr-2">{{data.titleBtn1}}</button>
  <button mat-button color="primary" cdkFocusInitial [mat-dialog-close]="true">{{data.titleBtn2}}</button>
</mat-dialog-actions>